export default __webpack_public_path__ + "static/media/ico_exclamation.05f054c6.svg";